import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const { login, loginWithGoogle } = useAuth();
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(credentials.username, credentials.password);
    } catch (error) {
      console.error('Login error:', error);
      setError('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    setLoading(true);
    try {
      await loginWithGoogle();
    } catch (error) {
      console.error('Google login error:', error);
      setError('Google login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img src="/logo.jpg" alt="addict" style={{ width: '80px', height: '80px', borderRadius: '12px', marginBottom: '10px' }} />
          <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#d4af37' }}>addict</div>
        </div>
        <div className="login-subtitle">Slipper Inventory Management</div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              placeholder="Enter username"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="Enter password"
              required
            />
          </div>
          
          {error && (
            <div style={{
              color: '#e74c3c',
              textAlign: 'center',
              marginBottom: '15px',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}
          
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
          
          <div style={{ margin: '15px 0', textAlign: 'center', color: '#8b7355' }}>or</div>
          
          <button type="button" onClick={handleGoogleLogin} className="google-btn" disabled={loading}>
            Sign in with Google
          </button>
          
          <div style={{
            textAlign: 'center',
            marginTop: '25px',
            paddingTop: '20px',
            borderTop: '1px solid #e8dcc0',
            fontSize: '12px',
            color: '#8b7355'
          }}>
            <div style={{ marginBottom: '8px' }}>
              © All rights reserved by <strong style={{ color: '#d4af37' }}>addict</strong>
            </div>
            <div>
              Powered by <strong style={{ color: '#d4af37' }}>Lunatech Creations Pvt Limited</strong>
            </div>
            <div style={{ marginTop: '4px', color: '#a0956b' }}>
              +94 74 018 1200
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;